import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import { ACTION_TAGS } from '../../../constants/actionTags';
import { actionTagIcons } from '../../../constants/iconMappings';

/**
 * Step 1: Action Tag Selection
 */
const Step1ActionTag = ({ tag, setTag, setStep }) => {
  return (
    <motion.div
      key="step1"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="step-content"
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '1rem' }} gutterBottom>
        Select an Action Tag
      </Typography>

      <Box className="action-tags-container">
        {ACTION_TAGS.map((actionTag) => (
          <div
            key={actionTag.id}
            className={`action-tag ${tag?.id === actionTag.id ? 'selected' : ''}`}
            onClick={() => {
              setTag(actionTag);
              setStep(2);
            }}
          >
            <div className="action-tag-content">
              <span className="action-tag-icon">
                {actionTagIcons[actionTag.id] || <IconX size={18} />}
              </span>
              <span className="action-tag-label">{actionTag.label}</span>
              <div className="action-tag-radio">
                {tag?.id === actionTag.id && <div className="radio-dot"></div>}
              </div>
            </div>
            <div className="action-tag-description">
              {actionTag.description}
            </div>
          </div>
        ))}
      </Box>
    </motion.div>
  );
};

export default Step1ActionTag;
